import { create } from 'zustand';

type ToastVariant = 'default' | 'success' | 'error';

interface Toast {
  id: string;
  title: string;
  description?: string;
  variant: ToastVariant;
}

interface ToastState {
  toast: Toast | null;
  showToast: (opts: { title: string; description?: string; variant?: ToastVariant }) => void;
  dismiss: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toast: null,
  showToast: ({ title, description, variant = 'default' }) => {
    const id = Date.now().toString();
    set({ toast: { id, title, description, variant } });
    setTimeout(() => {
      set((state) => (state.toast?.id === id ? { toast: null } : state));
    }, 3000);
  },
  dismiss: () => set({ toast: null }),
}));

// Convenience export
export const toast = (opts: { title: string; description?: string; variant?: ToastVariant }) => {
  useToastStore.getState().showToast(opts);
};
